const FaqParser = {};

FaqParser.getCategoriesParser = (res) => {
  if (!res) {
    return {};
  }

  const data = res.result.filter((item) => item.parent_id !== 0);

  if (res) {
    res = data.reverse();
    return res;
  }
};

FaqParser.getCategoriesParentParser = (res) => {
  if (!res) {
    return {};
  }

  if (res) {

    res = res.result.reverse();
    return res;
  }
};
FaqParser.getFaqParser = (res) => {
  if (res) {
    res = res.result;
    return res;
  }

  if (!res) {
    return [];
  }
};

FaqParser.getFaqKeywordParser = (res) => {
  if (res) {
    res = res.result;
    return res;
  }

  if (!res) {
    return [];
  }
};

export { FaqParser };
